module.exports = __webpack_public_path__ + "static/media/icon-user-circle.e53cdeb9.svg";